import React, { useEffect } from "react";
import ReactDOM from "react-dom";
import Loader from "./Loader";
import "./AppLoaderOverlay.css";

const AppLoaderOverlay = ({ message }) => {
    useEffect(() => {
        const { overflow } = document.body.style;
        document.body.style.overflow = "hidden";
        return () => {
            document.body.style.overflow = overflow;
        };
    }, []);

    const mountNode = document.querySelector("#commonModal");
    if (!mountNode) return null;

    return ReactDOM.createPortal(
        <div className="app-loader-overlay" role="alert" aria-busy="true" aria-live="assertive">
            <div className="app-loader-overlay-body">
                <div className="app-loader-overlay-spinner">
                    <Loader />
                </div>
                {message && <span className="app-loader-overlay-text">{message}</span>}
            </div>
        </div>,
        mountNode
    );
};

export default AppLoaderOverlay;
